export default {
  latestOffers: 'Latest Offers',
};
